import BadgesGridConfig from "./badges-grid-config";
import BadgesGridAdvancedConfig from "./badges-grid-advanced-config";
import dynamic from "next/dynamic";
const BadgesGridComponent = dynamic(()=>import("./badges-grid-component"));
export default {
    BadgesGridComponent,
    BadgesGridConfig,
    BadgesGridAdvancedConfig
};
